module.exports = {
    customer: 'poc',
    assets: { logo: 'logo.svg' }
    
};